import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hcrp6wvbfj: FaireBrandEntity = {
  token: "b_hcrp6wvbfj",
  type: "brand",
  name: "Tall Order",
  avatarUrl:
    "https://cdn.faire.com/fastly/f364767c241c32ff28ce8557cfecf2dcdbe9a19e09bcb0a7db93788d7ab1d8b2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/55e44604b01888e0793fe00ef891cea5b266a171f6f93377462f0f62f690023c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f364767c241c32ff28ce8557cfecf2dcdbe9a19e09bcb0a7db93788d7ab1d8b2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/55e44604b01888e0793fe00ef891cea5b266a171f6f93377462f0f62f690023c.jpeg",
  location: "GBR",
  minimumOrderDollars: 67,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: false,
  description:
    "Debi Beaumont is an illustrator and stationery designer based in a tiny village in the English countryside. Surrounded by hedgerows, birdsong, and changing seasons, she draws daily inspiration from the quiet beauty of rural life, reflected in her countryside illustration and nature stationery.\n\nWith a lifelong love of drawing, Debi founded Tall Order in 2020 to bring more thoughtfulness and joy into the world—one illustrated card at a time. Her collection of greeting cards, illustrated cards, blank notecards and eco greeting cards is rooted in small moments: daisies in the field behind her studio, a pet’s expression, the comfort of a handwritten note.\n\nAt its heart, Tall Order is about meaningful communication—encouraging people to slow down, pick up a pen, and connect in a more deliberate way, away from the noise of instant digital messaging. Each design begins as a hand-drawn illustration and becomes UK stationery that feels warm, uplifting, and personal.\n\nTall Order stationery has been purchased by thousands of customers worldwide, with over 4,000 five-star reviews. Retailers can feel confident they’re stocking a trusted, design-led brand.\n\nDebi is committed to sustainability, producing FSC cards on responsibly sourced stock, with plastic-free packaging and local UK production.\n\nThoughtful design for joyful giving.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:44.075Z",
    importedBy: "entity-db-cli",
  },
};
